export default class Time {
    hours: number
    minutes: number

    private get minutesString(): string {
        return this.minutes >= 10 ? `${this.minutes}` : `0${this.minutes}`
    }

    constructor(hours: number, minutes: number) {
        this.hours = hours
        this.minutes = minutes
    }

    static fromString(timeString: string): Time {
        const [hoursString, minutesString] = timeString.split(':')

        return new Time(
            Number(hoursString),
            Number(minutesString),
        )
    }

    diff(target: Time): number {
        return (this.hours * 60 + this.minutes) - (target.hours * 60 + target.minutes)
    }

    static fromDateTimeString(dateTimeString: string): {date: string, time: Time} {
        // noinspection JSUnusedLocalSymbols
        const [dateString, timeString] = dateTimeString.split('T')
        return {
            date: dateString,
            time: this.fromString(timeString),
        }
    }

    toJapaneseString(): string {
        return `${this.hours}時${this.minutesString}分`
    }

    toString(): string {
        return `${this.hours < 10 ? `0${this.hours}` : this.hours}:${this.minutesString}`
    }

    toJSON(): string {
        return `${this.hours}:${this.minutesString}`
    }
}
